<template>
  <div class="download-container">
    <iframe id="schema" style="display: none;"></iframe>

    <!-- 顶部导航栏 -->
    <div class="top-nav">
      <div class="nav-left">
        <img src="https://img.moliaos.com/v/logo.png" class="nav-logo" alt="陌撩漂流瓶" />
        <span class="nav-title">陌撩漂流瓶</span>
      </div>
      <div class="nav-right">
        <el-button class="main-download-btn" @click="jumpAppStore" round>
          <i class="el-icon-download"></i>
          立即下载
        </el-button>
      </div>
    </div>

    <!-- 主内容区域 -->
    <div class="main-content">
      <!-- Hero区域 - 首屏核心展示 -->
      <div class="hero-section">
        <div class="hero-badge">✨ 真实交友平台</div>
        <h1 class="hero-title">遇见有趣的人<br/>聊出专属默契</h1>
      </div>

      <!-- 应用场景展示 -->
      <div class="showcase-section">
        <h2 class="section-title">精彩瞬间</h2>
        <div class="showcase-scroll">
          <div class="showcase-item">
            <el-image :src="require('@/assets/img/main/1.png')" fit="cover" class="showcase-img"></el-image>
            <div class="showcase-caption">发现有趣灵魂</div>
          </div>
          <div class="showcase-item">
            <el-image :src="require('@/assets/img/main/2.png')" fit="cover" class="showcase-img"></el-image>
            <div class="showcase-caption">畅聊无限可能</div>
          </div>
          <div class="showcase-item">
            <el-image :src="require('@/assets/img/main/3.png')" fit="cover" class="showcase-img"></el-image>
            <div class="showcase-caption">建立真挚友谊</div>
          </div>
          <div class="showcase-item">
            <el-image :src="require('@/assets/img/main/4.png')" fit="cover" class="showcase-img"></el-image>
            <div class="showcase-caption">分享生活点滴</div>
          </div>
        </div>
      </div>

      <!-- 功能特色卡片 -->
      <div class="features-section">
        <h2 class="section-title">为什么选择陌撩？</h2>
        <div class="features-scroll">
          <div class="feature-card">
            <div class="feature-icon-wrapper">
              <div class="feature-icon icon-1">
                <i class="el-icon-user-solid"></i>
              </div>
            </div>
            <h3 class="feature-title">真实认证</h3>
            <p class="feature-desc">严格身份审核，确保每位用户真实可靠</p>
          </div>

          <div class="feature-card">
            <div class="feature-icon-wrapper">
              <div class="feature-icon icon-2">
                <i class="el-icon-chat-dot-round"></i>
              </div>
            </div>
            <h3 class="feature-title">趣味互动</h3>
            <p class="feature-desc">漂流瓶、话题匹配等多种社交玩法</p>
          </div>

          <div class="feature-card">
            <div class="feature-icon-wrapper">
              <div class="feature-icon icon-3">
                <i class="el-icon-lock"></i>
              </div>
            </div>
            <h3 class="feature-title">隐私保护</h3>
            <p class="feature-desc">完善的隐私设置，安全交友无忧虑</p>
          </div>

          <div class="feature-card">
            <div class="feature-icon-wrapper">
              <div class="feature-icon icon-4">
                <i class="el-icon-star-off"></i>
              </div>
            </div>
            <h3 class="feature-title">智能匹配</h3>
            <p class="feature-desc">AI算法推荐，找到志同道合的朋友</p>
          </div>
        </div>
      </div>

      <!-- 底部下载区域 -->
      <div class="bottom-download">
        <div class="download-content">
          <h2 class="bottom-title">立即开始社交之旅</h2>
          <p class="bottom-subtitle">免费下载，即刻体验</p>
          <el-button class="bottom-download-btn" @click="jumpAppStore" round size="large">
            <i class="el-icon-download"></i>
            立即下载
          </el-button>
        </div>
      </div>

      <!-- 营销合规提示 -->
      <div class="compliance-section">
        <p class="compliance-text">
          温馨提示：本应用为社交平台，请理性使用。回复TD退订 | 客服联系：support@moliaos.com
        </p>
      </div>
    </div>

    <!-- 底部固定导航栏 -->
    <div class="bottom-nav">
      <div class="bottom-nav-content">
        <div class="nav-info">
          <img src="https://img.moliaos.com/v/logo.png" class="nav-item-logo" alt="logo" />
          <div class="nav-text">
            <span class="nav-app-name">陌撩漂流瓶</span>
            <span class="nav-rating">
              <i class="el-icon-star-on"></i>
              4.9分
            </span>
          </div>
        </div>
        <el-button class="bottom-nav-download-btn" @click="jumpAppStore" round>
          免费下载
        </el-button>
      </div>
    </div>

    <!-- 页脚 -->
    <div class="footer">
      <div class="footer-content">
        <div class="footer-links">
          <a href="https://beian.miit.gov.cn/" class="footer-link">苏ICP备2023024575号-1</a>
          <span class="footer-divider">|</span>
          <a href="#" class="footer-link">用户协议</a>
          <span class="footer-divider">|</span>
          <a href="#" class="footer-link">隐私政策</a>
        </div>
        <p class="footer-copyright">© 2026 陌撩漂流瓶 版权所有</p>
      </div>
    </div>

    <!-- 微信/QQ 内置浏览器引导遮罩 -->
    <div v-if="showGuide" class="browser-guide-mask" @click="closeGuide">
      <div class="guide-arrow">
        <span class="arrow-icon">↗</span>
      </div>
      <div class="guide-tip" @click.stop>
        <p class="guide-title">前往浏览器打开</p>
        <p class="guide-desc">
          点击右上角「···」<br/>
          选择「在浏览器中打开」<br/>
          即可跳转应用商店下载
        </p>
        <div class="guide-divider"><span>或</span></div>
        <button class="guide-yyb-btn" @click="downloadByYingYongBao">
          应用宝直接下载
        </button>
        <p class="guide-close" @click="closeGuide">暂不下载</p>
      </div>
    </div>
  </div>
</template>

<script>export default {
  name: 'DownloadPage',
  data() {
    return {
      u: navigator.userAgent,
      ua: navigator.userAgent.toLowerCase(),
      // 微信/QQ 内置浏览器引导遮罩
      showGuide: false,
      guideType: 'wechat'
    }
  },
  mounted() {
    this.jumpAppStore();

    const img = document.createElement('img');
    img.src = '/man.png?t=' + Date.now();
    img.style.display = 'none';
    document.body.appendChild(img);
    setTimeout(() => {
      document.body.removeChild(img);
    }, 1000);
  },
  methods: {
    jumpAppStore() {
      const u = this.u;
      const ua = this.ua;

      // 操作系统检测
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
      const isIOS = /iPad|iPhone|iPod/.test(u);

      // 浏览器环境检测
      const isWechat = /MicroMessenger/i.test(u);
      const isQQ = !isWechat && /QQ\//i.test(u);

      // iOS 适配（iOS 版本尚未上线）
      if (isIOS) {
        this.$message({
          message: 'iOS版本即将上线，敬请期待',
          type: 'info',
          duration: 3000
        });
        return;
      }

      // 非安卓设备
      if (!isAndroid) {
        this.$message({
          message: '当前设备不支持下载，请使用安卓设备访问',
          type: 'warning',
          duration: 3000
        });
        return;
      }

      // 微信/QQ 内置浏览器：拦截自定义 scheme，显示引导遮罩
      if (isWechat || isQQ) {
        this.guideType = isWechat ? 'wechat' : 'qq';
        this.showGuide = true;
        return;
      }

      // 普通浏览器：按厂商跳转对应应用商店
      const isVivo = ua.indexOf('vivo') !== -1;
      const isHuawei = ua.indexOf('huawei') !== -1;
      const isHonor = ua.indexOf('honor') !== -1;
      const isMi = ua.indexOf('mi') !== -1;
      const isOppo = ua.indexOf('oppo') !== -1 || ua.indexOf('heytapbrowser') !== -1;
      const isOnePlus = ua.indexOf('oneplus') !== -1;
      const isSamsung = ua.indexOf('samsung') !== -1;
      const isLenovo = ua.indexOf('lenovo') !== -1;
      const isMeizu = ua.indexOf('meizu') !== -1;
      const isRealme = ua.indexOf('realme') !== -1;
      let jumpUrl = '';

      if (isVivo) {
        jumpUrl = 'vivoMarket://details?id=com.moliaos.android';
      } else if (isHuawei || isHonor) {
        jumpUrl = 'appmarket://details?id=com.moliaos.android';
      } else if (isOppo || isRealme) {
        jumpUrl = 'oppomarket://details?packagename=com.moliaos.android';
      } else if (isOnePlus) {
        jumpUrl = 'oppoMarket://details?packagename=com.moliaos.android';
      } else if (isMi) {
        jumpUrl = 'https://app.mi.com/details?id=com.moliaos.android';
      } else if (isSamsung) {
        jumpUrl = 'samsungapps://ProductDetail/com.moliaos.android';
      } else if (isLenovo) {
        jumpUrl = 'leappstore://details?id=com.moliaos.android';
      } else if (isMeizu) {
        jumpUrl = 'mzmarket://details?id=com.moliaos.android';
      } else {
        jumpUrl = 'market://details?id=com.moliaos.android';
      }

      if (jumpUrl !== '') {
        if (isMi) {
          window.location.href = jumpUrl;
        } else {
          document.getElementById("schema").src = jumpUrl;
        }
      }

      // 3 秒未成功唤起应用商店，则回退到 APK 直链下载
      const _clickTime = +new Date();
      setTimeout(() => {
        const elsTime = +new Date() - _clickTime;
        if (elsTime < 3100) {
          window.location.href = 'https://img.moliaos.com/v/moliao_other_1.8.0.apk';
        }
      }, 3000);
    },
    // 关闭引导遮罩
    closeGuide() {
      this.showGuide = false;
    },
    // 通过应用宝下载（微信/QQ 内置浏览器通用方案）
    downloadByYingYongBao() {
      this.showGuide = false;
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.moliaos.android';
    }
  }
}
</script>

<style scoped>/* ========== 全局样式 ========== */
.download-container {
  width: 100%;
  min-height: 100vh;
  margin: 0;
  padding-bottom: 80px;
  background: linear-gradient(180deg, #ffffff 0%, #fff5f9 50%, #ffffff 100%);
  overflow-x: hidden;
}

/* ========== 顶部导航栏 ========== */
.top-nav {
  height: 60px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  box-shadow: 0 2px 12px rgba(255, 96, 197, 0.08);
  border-bottom: 1px solid rgba(255, 96, 197, 0.1);
}

.nav-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.nav-logo {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(255, 96, 197, 0.2);
}

.nav-title {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  letter-spacing: 0.5px;
}

.main-download-btn {
  background: linear-gradient(135deg, #ff60c5 0%, #ff85d1 100%);
  color: #ffffff;
  border: none;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(255, 96, 197, 0.3);
}

.main-download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 96, 197, 0.4);
}

.main-download-btn i {
  margin-right: 4px;
}

/* ========== 主内容区域 ========== */
.main-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
  padding-top: 76px;
}

/* ========== Hero区域 ========== */
.hero-section {
  padding: 40px 0 50px;
  text-align: center;
  animation: fadeInUp 0.8s ease-out;
}

.hero-badge {
  display: inline-block;
  background: linear-gradient(135deg, #ff60c5 0%, #ff85d1 100%);
  color: #ffffff;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 20px;
  box-shadow: 0 4px 12px rgba(255, 96, 197, 0.3);
  animation: pulse 2s ease-in-out infinite;
}

.hero-title {
  font-size: 32px;
  font-weight: 700;
  color: #333333;
  margin-bottom: 16px;
  line-height: 1.4;
  letter-spacing: 1px;
}

/* ========== 功能特色区域 ========== */
.features-section {
  padding: 50px 0;
}

.section-title {
  font-size: 26px;
  font-weight: 700;
  color: #333333;
  text-align: center;
  margin-bottom: 35px;
  position: relative;
}

.section-title::after {
  content: '';
  display: block;
  width: 60px;
  height: 4px;
  background: linear-gradient(135deg, #ff60c5 0%, #ff85d1 100%);
  margin: 12px auto 0;
  border-radius: 2px;
}

.features-scroll {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  padding: 10px 4px 20px;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  margin-top: 30px;
}

.features-scroll::-webkit-scrollbar {
  display: none;
}

.feature-card {
  flex: 0 0 260px;
  scroll-snap-align: start;
  background: #ffffff;
  border-radius: 16px;
  padding: 30px 20px;
  text-align: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 96, 197, 0.1);
}

.feature-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 28px rgba(255, 96, 197, 0.15);
  border-color: rgba(255, 96, 197, 0.3);
}

.feature-icon-wrapper {
  margin-bottom: 16px;
}

.feature-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #ffffff;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.icon-1 {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.icon-2 {
  background: linear-gradient(135deg, #ff60c5 0%, #ff85d1 100%);
}

.icon-3 {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.icon-4 {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
}

.feature-title {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 10px;
}

.feature-desc {
  font-size: 14px;
  color: #666666;
  line-height: 1.6;
}

/* ========== 展示区域 ========== */
.showcase-section {
  padding: 50px 0;
}

.showcase-scroll {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  padding: 10px 0;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
}

.showcase-scroll::-webkit-scrollbar {
  display: none;
}

.showcase-item {
  flex: 0 0 260px;
  scroll-snap-align: start;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.showcase-item:hover {
  transform: scale(1.03);
  box-shadow: 0 10px 28px rgba(255, 96, 197, 0.2);
}

.showcase-img {
  width: 100%;
  height: 400px;
  display: block;
}

.showcase-caption {
  padding: 14px;
  background: #ffffff;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #333333;
}

/* ========== 底部下载区域 ========== */
.bottom-download {
  margin: 50px 0;
  background: linear-gradient(135deg, #ff60c5 0%, #ff85d1 100%);
  border-radius: 24px;
  padding: 50px 24px;
  text-align: center;
  position: relative;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(255, 96, 197, 0.3);
}

.bottom-download::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  animation: rotate 20s linear infinite;
}

.download-content {
  position: relative;
  z-index: 1;
}

.bottom-title {
  font-size: 26px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 12px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.bottom-subtitle {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 28px;
}

.bottom-download-btn {
  background: #ffffff;
  color: #ff60c5;
  border: none;
  padding: 16px 48px;
  font-size: 18px;
  font-weight: 700;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  margin-bottom: 12px;
}

.bottom-download-btn:hover {
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
}

.bottom-download-btn i {
  margin-right: 6px;
}

/* ========== 合规提示区域 ========== */
.compliance-section {
  padding: 20px 16px;
  text-align: center;
  background: rgba(255, 240, 245, 0.5);
  border-radius: 12px;
  margin-bottom: 30px;
}

.compliance-text {
  font-size: 12px;
  color: #999999;
  line-height: 1.8;
}

/* ========== 底部固定导航栏 ========== */
.bottom-nav {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(255, 96, 197, 0.1);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.06);
}

.bottom-nav-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.nav-item-logo {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(255, 96, 197, 0.2);
}

.nav-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.nav-app-name {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
}

.nav-rating {
  font-size: 12px;
  color: #ffa500;
}

.nav-rating i {
  margin-right: 2px;
}

.bottom-nav-download-btn {
  background: linear-gradient(135deg, #ff60c5 0%, #ff85d1 100%);
  color: #ffffff;
  border: none;
  padding: 10px 28px;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(255, 96, 197, 0.3);
  transition: all 0.3s ease;
}

.bottom-nav-download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 96, 197, 0.4);
}

/* ========== 页脚 ========== */
.footer {
  background: linear-gradient(135deg, #2d2d2d 0%, #1a1a1a 100%);
  padding: 30px 20px;
  margin-top: 40px;
  margin-bottom: 80px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.footer-links {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.footer-link {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: 12px;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: #ff60c5;
}

.footer-divider {
  color: rgba(255, 255, 255, 0.3);
  font-size: 12px;
}

.footer-copyright {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

/* ========== 动画效果 ========== */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* ========== 响应式设计 - 平板 ========== */
@media (max-width: 992px) {
  .hero-title {
    font-size: 28px;
  }

  .features-scroll {
    gap: 14px;
  }

  .feature-card {
    flex: 0 0 240px;
  }

  .section-title {
    font-size: 24px;
  }

  .bottom-title {
    font-size: 24px;
  }
}

/* ========== 响应式设计 - 手机 ========== */
@media (max-width: 768px) {
  .download-container {
    padding-bottom: 70px;
  }

  .top-nav {
    height: 56px;
    padding: 0 12px;
  }

  .nav-logo {
    width: 32px;
    height: 32px;
  }

  .nav-title {
    font-size: 15px;
  }

  .main-download-btn {
    padding: 6px 16px;
    font-size: 13px;
  }

  .main-content {
    padding: 0 12px;
    padding-top: 68px;
  }

  .hero-section {
    padding: 30px 0 40px;
  }

  .hero-badge {
    font-size: 12px;
    padding: 5px 14px;
    margin-bottom: 16px;
  }

  .hero-title {
    font-size: 24px;
    margin-bottom: 12px;
  }

  .features-section,
  .showcase-section {
    padding: 40px 0;
  }

  .section-title {
    font-size: 22px;
    margin-bottom: 28px;
  }

  .features-scroll {
    gap: 12px;
    padding: 8px 4px 16px;
  }

  .feature-card {
    flex: 0 0 220px;
    padding: 24px 16px;
  }

  .feature-icon {
    width: 60px;
    height: 60px;
    font-size: 28px;
  }

  .feature-title {
    font-size: 16px;
  }

  .feature-desc {
    font-size: 13px;
  }

  .showcase-item {
    flex: 0 0 220px;
  }

  .showcase-img {
    height: 340px;
  }

  .bottom-download {
    margin: 40px 0;
    padding: 40px 20px;
    border-radius: 20px;
  }

  .bottom-title {
    font-size: 22px;
  }

  .bottom-subtitle {
    font-size: 14px;
    margin-bottom: 24px;
  }

  .bottom-download-btn {
    padding: 14px 40px;
    font-size: 16px;
    width: 90%;
    max-width: 300px;
  }

  .compliance-section {
    padding: 16px 12px;
    margin-bottom: 24px;
  }

  .compliance-text {
    font-size: 11px;
  }

  .bottom-nav-content {
    padding: 10px 12px;
  }

  .nav-item-logo {
    width: 32px;
    height: 32px;
  }

  .nav-app-name {
    font-size: 13px;
  }

  .nav-rating {
    font-size: 11px;
  }

  .bottom-nav-download-btn {
    padding: 8px 20px;
    font-size: 13px;
  }

  .footer {
    padding: 24px 16px;
    margin-top: 30px;
    margin-bottom: 70px;
  }

  .footer-links {
    gap: 8px;
  }

  .footer-link {
    font-size: 11px;
  }

  .footer-copyright {
    font-size: 11px;
  }
}

/* ========== 超小屏幕优化 ========== */
@media (max-width: 375px) {
  .top-nav {
    padding: 0 10px;
  }

  .nav-logo {
    width: 30px;
    height: 30px;
  }

  .nav-title {
    font-size: 14px;
  }

  .main-download-btn {
    padding: 5px 12px;
    font-size: 12px;
  }

  .main-content {
    padding: 0 10px;
    padding-top: 66px;
  }

  .hero-section {
    padding: 24px 0 32px;
  }

  .hero-badge {
    font-size: 11px;
    padding: 4px 12px;
  }

  .hero-title {
    font-size: 22px;
  }

  .section-title {
    font-size: 20px;
  }

  .features-scroll {
    gap: 10px;
  }

  .feature-card {
    flex: 0 0 200px;
    padding: 20px 14px;
  }

  .showcase-item {
    flex: 0 0 200px;
  }

  .showcase-img {
    height: 300px;
  }

  .bottom-download {
    padding: 32px 16px;
  }

  .bottom-title {
    font-size: 20px;
  }

  .bottom-download-btn {
    padding: 12px 32px;
    font-size: 15px;
  }
}

/* ========== 横屏模式优化 ========== */
@media (max-height: 500px) and (orientation: landscape) {
  .top-nav {
    height: 48px;
  }

  .main-content {
    padding-top: 58px;
  }

  .hero-section {
    padding: 20px 0 30px;
  }

  .hero-title {
    font-size: 20px;
    margin-bottom: 10px;
  }

  .features-section,
  .showcase-section {
    padding: 30px 0;
  }

  .bottom-download {
    padding: 24px 16px;
    margin: 30px 0;
  }

  .footer {
    margin-top: 20px;
    padding: 20px 16px;
    margin-bottom: 60px;
  }
}

/* 微信/QQ 内置浏览器引导遮罩 */
.browser-guide-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.82);
  z-index: 9999;
}

.guide-arrow {
  position: absolute;
  top: 14px;
  right: 22px;
  color: #ffffff;
  font-size: 64px;
  line-height: 1;
  animation: guideArrowBounce 1.2s ease-in-out infinite;
}

@keyframes guideArrowBounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
}

.guide-tip {
  position: absolute;
  top: 96px;
  right: 16px;
  left: 16px;
  text-align: center;
  color: #ffffff;
}

.guide-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 14px;
  color: #ffffff;
}

.guide-desc {
  font-size: 15px;
  line-height: 1.85;
  color: rgba(255, 255, 255, 0.92);
  margin-bottom: 26px;
}

.guide-divider {
  display: flex;
  align-items: center;
  margin: 0 auto 22px;
  max-width: 240px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
}

.guide-divider::before,
.guide-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: rgba(255, 255, 255, 0.3);
}

.guide-divider span {
  padding: 0 12px;
}

.guide-yyb-btn {
  display: block;
  width: 100%;
  max-width: 280px;
  margin: 0 auto;
  padding: 13px 0;
  font-size: 16px;
  font-weight: 600;
  color: #ff60c5;
  background: #ffffff;
  border: none;
  border-radius: 26px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.guide-yyb-btn:active {
  transform: scale(0.97);
}

.guide-close {
  margin-top: 18px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
}
</style>
